<template>

 <div class="tab-pane fade" id="GameResult" role="tabpanel"  aria-labelledby="home-tab">
                <div style="padding-top:30px;">
                  <div class="b-b b-theme nav-active-theme mb-3">
                     <ul class="nav nav-pills" id="myTabchild2">
                      <li class="nav-item">
                        <a 
                        class="nav-link active" 
                        data-toggle="tab" 
                        href="#childreports_d"
                        role="tab" 
                        aria-controls="home" 
                        aria-selected="true">
                        Baccarat
                      </a>
                    </li>

                    <li class="nav-item">
                        <a 
                        class="nav-link" 
                        data-toggle="tab" 
                        href="#tabreplonghu"
                        role="tab" 
                        aria-controls="home" 
                        aria-selected="true">
                        Long Hu
                      </a>
                    </li>

                    <li class="nav-item">
                        <a 
                        class="nav-link" 
                        id="reportsa"
                        data-toggle="tab" 
                        href="#tabrepsicbo"
                        role="tab" 
                        aria-controls="home" 
                        aria-selected="true">
                        Sic Bo
                      </a>
                    </li>

                    <li class="nav-item">
                        <a 
                        class="nav-link" 
                        id="reportsa"
                        data-toggle="tab" 
                        href="#tabreproulette"
                        role="tab" 
                        aria-controls="home" 
                        aria-selected="true">
                        Roulette
                      </a>
                    </li>

                     
                     </ul>
                   </div>
                   <div class="tab-content mb-4">
                  <div class="tab-pane fade active show" id="childreports_d" role="tabpanel" aria-labelledby="home-tab">
                  <div class="row col-sm-12">
                  
                  <div class="col-sm-5">
                    <label class="col-sm-4 col-form-label" for="formGroupInputSmall">Date Range</label>
                    <div class="input-group input-daterange"><datepicker format="yyyy-MM-dd" value="2019-01-01" v-model="startdate" :bootstrap-styling="true" class="datewidth"></datepicker><div class="input-group-prepend"><span class="input-group-text">to</span></div><datepicker format="yyyy-MM-dd" value="2019-01-01" v-model="enddate" :bootstrap-styling="true" class="datewidth"></datepicker> </div>
                  </div>
                

                   <div class="col-sm-5"><label class="col-sm-4 col-form-label" for="formGroupInputSmall">Game Table</label><div class="col-sm-8"><input class="form-control form-control-sm" type="text" id="formGroupInputSmall" placeholder="Small input" v-model="gametable"></div></div>

                   <div class="col-sm-5"><label class="col-sm-4 col-form-label" for="formGroupInputSmall">Gameround ID</label><div class="col-sm-8"><input class="form-control form-control-sm" type="text" id="formGroupInputSmall" placeholder="Small input" v-model="edgameroundid"></div></div>

                   <div class="col-sm-5"><label class="col-sm-4 col-form-label" for="formGroupInputSmall">Card Set No</label><div class="col-sm-8"><input class="form-control form-control-sm" type="text" id="formGroupInputSmall" placeholder="Small input" v-model="edcardset"></div></div>

                  <div class="col-sm-1">
                     <button class="btn btn-primary btn-sm" @click="getreportbaccarat(startdate,enddate,gametable,edgameroundid,edcardset)">Search</button>
                  </div>
                </div>

                  <div class="">
                  <div class="row mt-3" style="overflow-x: auto; white-space: nowrap;">
                  <div style="padding-left: 15px; width:2000px;">
                     <h3>Baccarat</h3>
                    
  <div class="row" style="white-space: nowrap;">
      <div class="row col-12" style="padding-bottom:20px;">
      <b-col lg="6" class="">
        <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInputbacarat"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filterbacarat"
              type="search"
              id="filterInputbacarat"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>

        </b-form-group>
      </b-col>

        <b-col sm="3" md="6" class="my-1">
      
      </b-col>
    </div>

    
                      <b-table
                      bordered=true
                      dark=true
                
                      show-empty

                      selectable
                      select-mode="single"
                      selected-variant="primary"
                      :items="dtbacarat"
                      :fields="fields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filterbacarat"
                      :filterIncludedFields="filterOn"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      @filtered="onFiltered"
                      @row-selected="onRowSelectedMember"        
                    >
                       <template v-slot:cell(index)="data">
                        {{ data.index + 1 }} 
                      </template>

                     

                       <template v-slot:cell(roundStartTime)="data">
                        {{ moment(data.value).format("YYYY-MM-DD HH:mm:ss") }} 
                      </template>

                       <template v-slot:cell(betTime)="data">
                        {{ moment(data.value).format("YYYY-MM-DD HH:mm:ss") }} 
                      </template>
                    
                    </b-table>


                     <div class="row col-6">
    

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="dtbacarat.length"
          per-page="10"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </div>
                  </div>
                    
                  </div>
                  </div>
                </div>
                      </div>


                  <div class="tab-pane fade" id="tabreplonghu" role="tabpanel" aria-labelledby="home-tab">
                  <div class="row col-sm-12">
                  
                  <div class="col-sm-5">
                    <label class="col-sm-4 col-form-label" for="formGroupInputSmall">Date Range</label>
                    <div class="input-group input-daterange"><datepicker format="yyyy-MM-dd" value="2019-01-01" v-model="startdate_l"></datepicker><div class="input-group-prepend"><span class="input-group-text">to</span></div><datepicker format="yyyy-MM-dd" value="2019-01-01" v-model="enddate_l"></datepicker> </div>
                  </div>
                 

                   <div class="col-sm-5"><label class="col-sm-4 col-form-label" for="formGroupInputSmall">Game Table</label><div class="col-sm-8"><input class="form-control form-control-sm" type="text" id="formGroupInputSmall" placeholder="Small input" v-model="gametable_l"></div></div>

                   <div class="col-sm-5"><label class="col-sm-4 col-form-label" for="formGroupInputSmall">Gameround ID</label><div class="col-sm-8"><input class="form-control form-control-sm" type="text" id="formGroupInputSmall" placeholder="Small input" v-model="edgameroundid_l"></div></div>

                   <div class="col-sm-5"><label class="col-sm-4 col-form-label" for="formGroupInputSmall">Card Set No</label><div class="col-sm-8"><input class="form-control form-control-sm" type="text" id="formGroupInputSmall" placeholder="Small input" v-model="edcardset_l"></div></div>

                  <div class="col-sm-1">
                     <button class="btn btn-primary btn-sm" @click="getreportlonghu(startdate_l,enddate_l,gametable_l,edgameroundid_l,edcardset_l)">Search</button>
                  </div>
                </div>

                  <div class="">
                  <div class="row mt-3" style="overflow-x: auto; white-space: nowrap;">
                  <div style="padding-left: 15px; width:2000px;">
                     <h3>LongHu</h3>
                    
                    <div class="row" style="white-space: nowrap;">
      <div class="row col-12" style="padding-bottom:20px;">
      <b-col lg="6" class="">
        <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInputLonghu"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filterLonghu"
              type="search"
              id="filterInputLonghu"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>

        </b-form-group>
      </b-col>

        <b-col sm="3" md="6" class="my-1">
      
      </b-col>
    </div>

    
                      <b-table
                      bordered=true
                      dark=true
                
                      show-empty

                      selectable
                      select-mode="single"
                      selected-variant="primary"
                      :items="dtlonghu"
                      :fields="fields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filterLonghu"
                      :filterIncludedFields="filterOn"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      @filtered="onFiltered"
                      @row-selected="onRowSelectedMember"
                 
                    >
                       <template v-slot:cell(index)="data">
                        {{ data.index + 1 }} 
                      </template>

                        <template v-slot:cell(roundStartTime)="data">
                        {{ moment(data.value).format("YYYY-MM-DD HH:mm:ss") }} 
                      </template>

                       <template v-slot:cell(betTime)="data">
                        {{ moment(data.value).format("YYYY-MM-DD HH:mm:ss") }} 
                      </template>
                    
                    </b-table>


                     <div class="row col-6">
    

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="dtlonghu.length"
          per-page="10"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </div>
                  </div>

                   
                  </div>
                  </div>
                </div>
                      </div>

          
                  <div class="tab-pane fade" id="tabrepsicbo" role="tabpanel" aria-labelledby="home-tab">
                  <div class="row col-sm-12">
                  
                  <div class="col-sm-5">
                    <label class="col-sm-4 col-form-label" for="formGroupInputSmall">Date Range</label>
                    <div class="input-group input-daterange"><datepicker format="yyyy-MM-dd" value="2019-01-01" v-model="startdate_s"></datepicker><div class="input-group-prepend"><span class="input-group-text">to</span></div><datepicker format="yyyy-MM-dd" value="2019-01-01" v-model="enddate_s"></datepicker> </div>
                  </div>
                  

                   <div class="col-sm-5"><label class="col-sm-4 col-form-label" for="formGroupInputSmall">Game Table</label><div class="col-sm-8"><input class="form-control form-control-sm" type="text" id="formGroupInputSmall" placeholder="Small input" v-model="gametable_s"></div></div>

                   <div class="col-sm-5"><label class="col-sm-4 col-form-label" for="formGroupInputSmall">Gameround ID</label><div class="col-sm-8"><input class="form-control form-control-sm" type="text" id="formGroupInputSmall" placeholder="Small input" v-model="edgameroundid_s"></div></div>

                   <div class="col-sm-5"><label class="col-sm-4 col-form-label" for="formGroupInputSmall">Card Set No</label><div class="col-sm-8"><input class="form-control form-control-sm" type="text" id="formGroupInputSmall" placeholder="Small input" v-model="edcardset_s"></div></div>

                  <div class="col-sm-1">
                     <button class="btn btn-primary btn-sm" @click="getreportsicbo(startdate_s,enddate_s,gametable_s,edgameroundid_s,edcardset_s)">Search</button>
                  </div>
                </div>

                  <div class="">
                  <div class="row mt-3" style="overflow-x: auto; white-space: nowrap;">
                  <div style="padding-left: 15px; width:2000px;">
                     <h3>Sicbo</h3>
                    
                    <div class="row" style="white-space: nowrap;">
      <div class="row col-12" style="padding-bottom:20px;">
      <b-col lg="6" class="">
        <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInputSicbo"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filterSicbo"
              type="search"
              id="filterInputSicbo"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>

        </b-form-group>
      </b-col>

        <b-col sm="3" md="6" class="my-1">
      
      </b-col>
    </div>

    
                      <b-table
                      bordered=true
                      dark=true
                
                      show-empty

                      selectable
                      select-mode="single"
                      selected-variant="primary"
                      :items="dtsicbo"
                      :fields="fields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filterSicbo"
                      :filterIncludedFields="filterOn"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      @filtered="onFiltered"
                      @row-selected="onRowSelectedMember"
                 
                    >
                       <template v-slot:cell(index)="data">
                        {{ data.index + 1 }} 
                      </template>

                        <template v-slot:cell(roundStartTime)="data">
                        {{ moment(data.value).format("YYYY-MM-DD HH:mm:ss") }} 
                      </template>

                       <template v-slot:cell(betTime)="data">
                        {{ moment(data.value).format("YYYY-MM-DD HH:mm:ss") }} 
                      </template>
                    
                    </b-table>


                     <div class="row col-6">
    

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="dtsicbo.length"
          per-page="10"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </div>
                  </div>

                  </div>
                  </div>
                </div>
                      </div>


                  <div class="tab-pane fade" id="tabreproulette" role="tabpanel" aria-labelledby="home-tab">
                  <div class="row col-sm-12">
                  
                  <div class="col-sm-5">
                    <label class="col-sm-4 col-form-label" for="formGroupInputSmall">Date Range</label>
                    <div class="input-group input-daterange"><datepicker format="yyyy-MM-dd" value="2019-01-01" v-model="startdate_r"></datepicker><div class="input-group-prepend"><span class="input-group-text">to</span></div><datepicker format="yyyy-MM-dd" value="2019-01-01" v-model="enddate_r"></datepicker> </div>
                  </div>
              

                   <div class="col-sm-5"><label class="col-sm-4 col-form-label" for="formGroupInputSmall">Game Table</label><div class="col-sm-8"><input class="form-control form-control-sm" type="text" id="formGroupInputSmall" placeholder="Small input" v-model="gametable_r"></div></div>

                   <div class="col-sm-5"><label class="col-sm-4 col-form-label" for="formGroupInputSmall">Gameround ID</label><div class="col-sm-8"><input class="form-control form-control-sm" type="text" id="formGroupInputSmall" placeholder="Small input" v-model="edgameroundid_r"></div></div>

                   <div class="col-sm-5"><label class="col-sm-4 col-form-label" for="formGroupInputSmall">Card Set No</label><div class="col-sm-8"><input class="form-control form-control-sm" type="text" id="formGroupInputSmall" placeholder="Small input" v-model="edcardset_r"></div></div>

                  <div class="col-sm-1">
                     <button class="btn btn-primary btn-sm" @click="getreportroulette(startdate_r,enddate_r,gametable_r,edgameroundid_r,edcardset_r)">Search</button>
                  </div>
                </div>

                  <div class="">
                  <div class="row mt-3" style="overflow-x: auto; white-space: nowrap;">
                  <div style="padding-left: 15px; width:2000px;">
                     <h3>Roulette</h3>
                    
                    <div class="row" style="white-space: nowrap;">
      <div class="row col-12" style="padding-bottom:20px;">
      <b-col lg="6" class="">
        <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInputRou"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filterRou"
              type="search"
              id="filterInputRou"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>

        </b-form-group>
      </b-col>

        <b-col sm="3" md="6" class="my-1">
      
      </b-col>
    </div>

    
                      <b-table
                      bordered=true
                      dark=true
                
                      show-empty

                      selectable
                      select-mode="single"
                      selected-variant="primary"
                      :items="dtrou"
                      :fields="fields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filterRou"
                      :filterIncludedFields="filterOn"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      @filtered="onFiltered"
                      @row-selected="onRowSelectedMember"
                 
                    >
                       <template v-slot:cell(index)="data">
                        {{ data.index + 1 }} 
                      </template>
                       <template v-slot:cell(roundStartTime)="data">
                        {{ moment(data.value).format("YYYY-MM-DD HH:mm:ss") }} 
                      </template>

                       <template v-slot:cell(betTime)="data">
                        {{ moment(data.value).format("YYYY-MM-DD HH:mm:ss") }} 
                      </template>
                    
                    </b-table>


                     <div class="row col-6">
    

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="dtrou.length"
          per-page="10"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </div>
                  </div>

                    
                  </div>
                  </div>
                </div>
                      </div>

                   </div>
                </div>
                </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import { mapGetters } from "vuex";
    import * as TYPES from "@/store/mutation-types";
    import api from '@/api'
    import moment from 'moment'

export default {
  name: "gameresultreport",
  components: {
    Datepicker
  },
  data: function() {
    return {
      dataTable:null,
      dataLonghu:null,
      dataSicbo:null,
      datarou:null,
      dtbacarat : [],
      dtlonghu : [],
      dtsicbo : [],
      datarou : [],
      DatePickerFormat: 'yyyy-MM-dd',
      arrtablegame : {
        tableid : ""
      },
      fields: [
          'index',
          { key : 'roundId', label : 'Game Round Id'},
          { key: 'gameType', label: 'Game Type', sortable: true,  },
          { key: 'tableId', label: 'Game Table'},
          { key: 'roundStartTime', label: 'Start Date'},
          { key: 'betTime', label: 'End Date'},
          { key: 'card', label: 'Card Set No'},
          { key: 'result', label: 'Game Result'},
          { key: 'video', label: 'Video'},
          { key: 'status', label: 'Game Status'}
        ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filterbacarat : null,
      filterLonghu : null,
      filterSicbo : null,
      filterRou : null,
      filterOn: [],
    }
  },
 
   computed: {
   ...mapGetters(["allBetRecords","allBetBaccarats","allBetLonghu","allBetSicbo","allBetRoulette"]),
   getAllBetRecords(){
      return this.allBetRecords
   },
   getAllBetBaccarat(){
      return this.allBetBaccarats
   },
   getAllBetLonghu(){
      return this.allBetLonghu
   },
   getAllBetSicbo(){
      return this.allBetSicbo
   },
   getAllBetRoulette(){
      return this.allBetRoulette
   }
  },
  methods : {
     getreport(gametype,clientname){
        
        let par = {
           gametype : gametype,
           clientname : clientname
        }
        this.$store.dispatch(TYPES.FETCH_BETRECORDS, par)
            
     },
    doMath: function(index) {
      return index+1
    },
  moment: function (time) {
    return moment(time);
  },
    customFormatter(date) {
      return date.format('MMMM Do YYYY, h:mm:ss a');
    },
    doMath: function(index) {
        return index+1
      },
    getreportroulette(awal='',akhir='',gametable='',gameroundid='',cardsetno=''){
       let myarr = this.getAllBetRoulette
       var filter = new Object();

      if (gametable != ''){
         Object.assign(filter, {tableId: gametable});
      }
      if (gameroundid != ''){
         Object.assign(filter, {roundId: gameroundid});
      }
      var arr2 = myarr.filter(function(item) {
          for (var key in filter) {
            if (item[key] === undefined || item[key] != filter[key])
              return false;
            }
          return true;
      });

      var filter2 = new Object();

       if (awal != ''){
         Object.assign(filter2, {roundStartTime: awal});
       }


       var arr = arr2.filter(function(item) {
          for (var key in filter2) {
            
            var itemTime = new Date(item['betTime']).getDate();
            var newawal = new Date(awal).getDate();
            var newakhir =  new Date(akhir).getDate();

            if (itemTime < newawal || itemTime > newakhir) 
              return false;
            }
          return true;
      });

     /*  this.datarou.clear().draw()
       for (var i = arr.length - 1; i >= 0; i--) {
         
         
          this.datarou.row.add([i+1,arr[i].roundId,arr[i].gameType,arr[i].tableId,
            moment(arr[i].roundStartTime).format("dddd, MMMM Do YYYY"),moment(arr[i].betTime).format("dddd, MMMM Do YYYY"),'',arr[i].result,'',
            arr[i].status
          ]).draw(false)

      }*/
      this.dtrou = arr;

    },
    getreportsicbo(awal='',akhir='',gametable='',gameroundid='',cardsetno=''){

       let myarr = this.getAllBetSicbo
       
       var filter = new Object();

      if (gametable != ''){
         Object.assign(filter, {tableId: gametable});
      }
      if (gameroundid != ''){
         Object.assign(filter, {roundId: gameroundid});
      }
      var arr2 = myarr.filter(function(item) {
          for (var key in filter) {
            if (item[key] === undefined || item[key] != filter[key])
              return false;
            }
          return true;
      });

      var filter2 = new Object();

       if (awal != ''){
         Object.assign(filter2, {roundStartTime: awal});
       }


       var arr = arr2.filter(function(item) {
          for (var key in filter2) {
            
            var itemTime = new Date(item['betTime']).getDate();
            var newawal = new Date(awal).getDate();
            var newakhir =  new Date(akhir).getDate();

            if (itemTime < newawal || itemTime > newakhir) 
              return false;
            }
          return true;
      });

      /* this.dataSicbo.clear().draw()
       for (var i = arr.length - 1; i >= 0; i--) {
          
         
          this.dataSicbo.row.add([i+1,arr[i].roundId,arr[i].gameType,arr[i].tableId,
            moment(arr[i].roundStartTime).format("dddd, MMMM Do YYYY"),moment(arr[i].betTime).format("dddd, MMMM Do YYYY"),'',arr[i].result,'',
            arr[i].status
          ]).draw(false)

      }*/

      this.dtsicbo = arr;

    },
    getreportbaccarat(awal='',akhir='',gametable='',gameroundid='',cardsetno=''){
       let myarr = this.getAllBetBaccarat
       var filter = new Object();

      if (gametable != ''){
         Object.assign(filter, {tableId: gametable});
      }
      if (gameroundid != ''){
         Object.assign(filter, {roundId: gameroundid});
      }
      var arr2 = myarr.filter(function(item) {
          for (var key in filter) {
            if (item[key] === undefined || item[key] != filter[key])
              return false;
            }
          return true;
      });

      var filter2 = new Object();

       if (awal != ''){
         Object.assign(filter2, {roundStartTime: awal});
       }


       var arr = arr2.filter(function(item) {
          for (var key in filter2) {
            
            var itemTime = new Date(item['betTime']).getDate();
            var newawal = new Date(awal).getDate();
            var newakhir =  new Date(akhir).getDate();

            if (itemTime < newawal || itemTime > newakhir) 
              return false;
            }
          return true;
      });

      // this.dataTable.clear().draw()
       this.dtbacarat = arr;
      /* for (var i = arr.length - 1; i >= 0; i--) {
          
         
          this.dataTable.row.add([i+1,arr[i].roundId,arr[i].gameType,arr[i].tableId,
            moment(arr[i].roundStartTime).format("dddd, MMMM Do YYYY"),moment(arr[i].betTime).format("dddd, MMMM Do YYYY"),'',arr[i].result,'',
            arr[i].status
          ]).draw(false)

      }*/

    },
    getreportlonghu(awal='',akhir='',gametable='',gameroundid='',cardsetno=''){
       let myarr = this.getAllBetLonghu
      // debugger;
       var filter = new Object();

      if (gametable != ''){
         Object.assign(filter, {tableId: gametable});
      }
      if (gameroundid != ''){
         Object.assign(filter, {roundId: gameroundid});
      }
      var arr2 = myarr.filter(function(item) {
          for (var key in filter) {
            if (item[key] === undefined || item[key] != filter[key])
              return false;
            }
          return true;
      });

      var filter2 = new Object();

       if (awal != ''){
         Object.assign(filter2, {roundStartTime: awal});
       }


       var arr = arr2.filter(function(item) {
          for (var key in filter2) {
            
            var itemTime = new Date(item['betTime']).getDate();
            var newawal = new Date(awal).getDate();
            var newakhir =  new Date(akhir).getDate();

            if (itemTime < newawal || itemTime > newakhir) 
              return false;
            
            }
          return true;
      });

     /*  this.dataLonghu.clear().draw()
       for (var i = arr.length - 1; i >= 0; i--) {
         
         
          this.dataLonghu.row.add([i+1,arr[i].roundId,arr[i].gameType,arr[i].tableId,
            moment(arr[i].roundStartTime).format("dddd, MMMM Do YYYY"),moment(arr[i].betTime).format("dddd, MMMM Do YYYY"),'',arr[i].result,'',
            arr[i].status
          ]).draw(false)

      }*/

      this.dtlonghu = arr;

    }
  },
  created(){
    // this.getreport("","");
     let par = {
           gametype : '',
           clientname : ''
        }
   // this.$store.dispatch(TYPES.FETCH_BETRECORDS, par)
  },
   mounted(){  
      this.dataTable = $('#tabgameresult').DataTable({}); 
      this.dataLonghu = $('#tabgamelonghu').DataTable({});
      this.dataSicbo = $('#tabgamesicbo').DataTable({});
      this.datarou = $('#tabgameroulette').DataTable({});




     /* let myarr = this.allBetRecords;

     

      var mytabarr = [];

      for (var i = myarr.length - 1; i >= 0; i--) {
        if (!mytabarr.includes(myarr[i].tableId)){
              mytabarr.push(myarr[i].tableId);
        }
      }

      this.arrtablegame = mytabarr;*/

      this.getreportbaccarat();
      this.getreportlonghu();
      this.getreportroulette();
      this.getreportsicbo();
      
   }
}
</script>